var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#DEECFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5833 18.1667H30.4167M24 24C22.1435 24 20.363 24.7375 19.0503 26.0503C17.7375 27.363 17 29.1435 17 31V33.3333C17 33.6428 17.1229 33.9395 17.3417 34.1583C17.5605 34.3771 17.8572 34.5 18.1667 34.5H29.8333C30.1428 34.5 30.4395 34.3771 30.6583 34.1583C30.8771 33.9395 31 33.6428 31 33.3333V31C31 29.1435 30.2625 27.363 28.9497 26.0503C27.637 24.7375 25.8565 24 24 24ZM24 24C22.1435 24 20.363 23.2625 19.0503 21.9497C17.7375 20.637 17 18.8565 17 17V14.6667C17 14.3572 17.1229 14.0605 17.3417 13.8417C17.5605 13.6229 17.8572 13.5 18.1667 13.5H29.8333C30.1428 13.5 30.4395 13.6229 30.6583 13.8417C30.8771 14.0605 31 14.3572 31 14.6667V17C31 18.8565 30.2625 20.637 28.9497 21.9497C27.637 23.2625 25.8565 24 24 24Z",
    stroke: "#3A8AF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/Risk.0f7c12a1c36fe1caba968b96909f6c08.svg";
export { ForwardRef as ReactComponent };